import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var HappyChatBubble = function HappyChatBubble(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp || color : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 96 96",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.44995 90.575L10.325 66.6C7.44995 60.775 5.99995 54.525 5.99995 48C5.99995 24.85 24.85 6 48 6C71.1499 6 90 24.85 90 48C90 71.15 71.1499 90 48 90C41.4749 90 35.2249 88.55 29.4249 85.675L5.44995 90.575ZM30 81.475L30.625 81.8C36.025 84.575 41.875 86 48 86C68.95 86 86 68.95 86 48C86 27.05 68.95 10 48 10C27.0499 10 9.99995 27.05 9.99995 48C9.99995 54.125 11.4 59.975 14.2 65.375L14.525 66L10.575 85.425L30 81.475Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M47.9999 72.0001C37.8249 72.0001 28.9749 66.1751 25.45 57.1751L29.1749 55.7251C32.0749 63.1751 39.4749 68.0001 47.9999 68.0001C56.5249 68.0001 63.8999 63.1751 66.8249 55.7251L70.5499 57.1751C67.0249 66.1751 58.1749 72.0001 47.9999 72.0001Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M70.1501 40H66.1501C66.1501 39.2 64.4001 38 62.0001 38C59.6001 38 57.8501 39.2 57.8501 40H53.8501C53.8501 36.625 57.4251 34 62.0001 34C66.5751 34 70.1501 36.625 70.1501 40Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M42.1502 40H38.1502C38.1502 39.2 36.4002 38 34.0002 38C31.6002 38 29.8502 39.2 29.8502 40H25.8502C25.8502 36.625 29.4252 34 34.0002 34C38.5752 34 42.1502 36.625 42.1502 40Z",
      fill: secondaryColor
    })]
  });
};
export default HappyChatBubble;